<template>
  <div class="page">
    <Loading v-if="isLoading" />
    <div v-else class="paper-content">
      <div class="paper-item" v-for="(item,index) in newspapers.data" v-bind:key="index">
        <router-link :to="{name: 'PaperInfo', params:{id: item.id}}" class="preview-link">
             <div class="paper-img"><img :src="item.image" /></div>
             <p class="paper-tit">{{item.name}}</p>
          </router-link>
      </div>    
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// eslint-disable-next-line no-unused-vars
import { FETCH_NEWSPAPERS,FETCH_NEWSPAPERINFO  } from "@/store/actions.type";
import Loading from "@/components/Loading";

export default {
  name: "PaperList",
  components: {
    Loading
  },
  computed: {
    ...mapGetters(["isLoading", "newspapers"]),
    listConfig() {
      const limit = 100;
      return {
        limit
      };
    },
  },
  mounted() {
    this.fetchNewspapers();
  },
  methods: {
    fetchNewspapers() {
      this.$store.dispatch(FETCH_NEWSPAPERS, this.listConfig);
    },
  }
};
</script>
